import { render, staticRenderFns } from "./tableBox.vue?vue&type=template&id=1a95e3e7&scoped=true"
import script from "./tableBox.vue?vue&type=script&lang=js"
export * from "./tableBox.vue?vue&type=script&lang=js"
import style0 from "./tableBox.vue?vue&type=style&index=0&id=1a95e3e7&prod&lang=stylus&scoped=true"
import style1 from "./tableBox.vue?vue&type=style&index=1&id=1a95e3e7&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a95e3e7",
  null
  
)

export default component.exports